import { getUserProfile, getClientWalletMapping } from "../api";
import rules from "../rbac-rules";
import { login, logout } from "../api/login";
import SecureSS, {
  JWT_TOKEN,
  USER_PROFILE,
  CLIENT_WALLET_MAPPING
} from "../utils/secure-xs/secureSS";
import { toast } from "react-toastify";
import ReactGA from "react-ga";

export const DO_AUTHENTICATE = "DO_AUTHENTICATE";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
export const SET_IS_LOGIN = "SET_IS_LOGIN";
export const LOGOUT = "LOGOUT";

/*
 * action creators
 */

export const doAuthenticate = () => ({ type: DO_AUTHENTICATE });

export const setLoginError = errorMessage => {
  return { type: SET_LOGIN_ERROR, errorMessage };
};
export const setIsLoggingIn = isLoggingIn => {
  return { type: SET_IS_LOGIN, isLoggingIn };
};
export const handleLogout = () => {
  return { type: LOGOUT };
};
export const asyncGetUserProfile = (callback, dispatch) => {
  dispatch(setIsLoggingIn(true));
  getUserProfile().then(
    success => {
      dispatch(setIsLoggingIn(false));
      const userProfileData = success.body;
      if (userProfileData) {
        ReactGA.initialize("UA-177866127-1");
        ReactGA.set({ userId: userProfileData.username });
        const { role } = userProfileData;
        if (!role) {
          return toast.error("User has no role!");
        }
        SecureSS.set(USER_PROFILE, userProfileData);
        if (userProfileData.userType === "CLIENT") {
          asyncGetClientWalletMapping(dispatch, userProfileData.clientId);
        }
        const homePage =
          userProfileData.userType === "SUPPLIER"
            ? "/home"
            : rules[role].homePage;

        callback({
          authenticated: true,
          user: {
            role,
            ...userProfileData
          },
          homePage
        });
      }
    },
    failure => {
      dispatch(setIsLoggingIn(false));
      console.log(failure);
    }
  );
};

export const asyncGetClientWalletMapping = (dispatch, clientId) => {
  getClientWalletMapping(clientId).then(
    success => {
      const walletMappingData = success.body;
      if (walletMappingData) {
        SecureSS.set(CLIENT_WALLET_MAPPING, walletMappingData);
      }
    },
    failure => {
      console.log(failure);
    }
  );
};

export function asyncAdminConsoleLogin(user, dispatch, callback) {
  dispatch(setLoginError(""));
  dispatch(setIsLoggingIn(true));
  const newUser = { username: user.j_username, password: user.j_password };
  return login(newUser)
    .then(resp => {
      if (resp?.body?.authentication) {
        SecureSS.set(JWT_TOKEN, resp.body.authentication.accessToken);
        asyncGetUserProfile(callback, dispatch);
        return;
      }
      dispatch(setIsLoggingIn(false));
      dispatch(setLoginError(resp?.body?.responseText || "Unable to login"));
    })
    .catch(error => {
      dispatch(setIsLoggingIn(false));
      console.error(error);
      dispatch(setLoginError("Unable to login"));
    });
}
export function asyncClientMgmtLogout(dispatch, callback) {
  dispatch(setIsLoggingIn(true));
  return logout()
    .then(resp => {
      dispatch(setIsLoggingIn(false));
      sessionStorage.clear();
      callback();
    })
    .catch(error => {
      dispatch(setIsLoggingIn(false));
      console.error(error);
      sessionStorage.clear();
      callback();
    });
}
